var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHideTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7422C14.9658 18.7422 19.0791 14.6377 19.0791 9.66309C19.0791 4.69727 14.9658 0.583984 9.99121 0.583984C5.02539 0.583984 0.920898 4.69727 0.920898 9.66309C0.920898 14.6377 5.03418 18.7422 10 18.7422ZM10 13.3809C6.52832 13.3809 4.10254 10.5508 4.10254 9.67188C4.10254 8.79297 6.51074 5.96289 10 5.96289C13.498 5.96289 15.8887 8.79297 15.8887 9.67188C15.8887 10.5508 13.5068 13.3809 10 13.3809ZM10 12.0713C11.3271 12.0713 12.4082 10.9727 12.4082 9.67188C12.4082 8.33594 11.3271 7.26367 10 7.26367C8.66406 7.26367 7.58301 8.33594 7.58301 9.67188C7.58301 10.9727 8.66406 12.0713 10 12.0713ZM10.0088 10.7266C9.42871 10.7266 8.94531 10.2344 8.94531 9.67188C8.94531 9.10938 9.42871 8.61719 10.0088 8.61719C10.5713 8.61719 11.0635 9.10938 11.0635 9.67188C11.0635 10.2344 10.5713 10.7266 10.0088 10.7266Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideTagIcon);
export default __webpack_public_path__ + "static/media/hide_tag-icon.d4dcfe1491f1a4a88ee90030fd1ae163.svg";
export { ForwardRef as ReactComponent };